<!-- Process Spinner Content -->
<div class="flex justify-content-center">
  <p-progressSpinner styleClass="w-{{width}}rem h-{{width}}rem"
                     strokeWidth="8"
                     fill="var(--surface-ground)"
                     animationDuration=".5s">
  </p-progressSpinner>
</div>